<template>
  <div
      v-if="$_.get(form.errors.errors, this.name, null)"
  >
    <div v-for="(val, key) in $_.get(form.errors.errors.invites[this.index], this.field)">
      <div class="invalid-feedback d-block">{{ val }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'form': {},
    'name': '',
    'field': '',
    'index': 0,
  }
}
</script>